import { Modal } from '../common/Modal';

type PhysicalFileRetrievalModalProps = {
  open: boolean;
  submitting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

/** Data dictionary — confirmation before initiating Record Room physical file retrieval. */
export function PhysicalFileRetrievalModal({
  open,
  submitting = false,
  onClose,
  onConfirm,
}: PhysicalFileRetrievalModalProps) {
  return (
    <Modal
      open={open}
      title="Physical File Retrieval Request"
      boxClassName="cn-mbox-confirm"
      onClose={() => {
        if (!submitting) onClose();
      }}
    >
      <p className="cn-confirm-msg">
        Are you sure you want to retrieve the physical file from Record Room?
      </p>
      <div className="cn-confirm-delete-actions">
        <button className="mfb" type="button" disabled={submitting} onClick={onClose}>
          No
        </button>
        <button className="mfb mfb-dk" type="button" disabled={submitting} onClick={onConfirm}>
          {submitting ? 'Submitting…' : 'Yes'}
        </button>
      </div>
    </Modal>
  );
}
